import {
    Directive,
    ElementRef,
    HostListener
} from "@angular/core";

@Directive({
    selector: "[mytabindex]"
})
export class TabindexDirective {

    constructor(public el: ElementRef) {
    }

    @HostListener("keydown", ["$event"])
    onInputChange(e): void {
        const code = e.keyCode || e.which;

        if (code === 13) {
            e.preventDefault();
            // this.inputRef.focusNext();
        }
    }
}



// WEBPACK FOOTER //
// ./src/vas/directives/tabindex.directive.ts